import { ReactNode } from "react";

import { css } from "@compiled/react";

import Form from "@atlaskit/form";

import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { useSiteActivationContext } from "../../hooks/site-activation-context";
import { SiteNameInput as DefaultSiteNameInput } from "../common/site-name-input";

import { SitePicker as DefaultSitePicker } from "./site-picker";
import { SiteToggleButton as DefaultSiteToggleButton } from "./site-toggle-button";
import { ExistingSitesSubmitButton as DefaultSubmitButton } from "./submit-button";

export const Content = ({
    SitePicker = <DefaultSitePicker />,
    SiteNameInput = <DefaultSiteNameInput />,
    SiteToggleButton = <DefaultSiteToggleButton />,
    SubmitButton = <DefaultSubmitButton />,
    PrivacyPolicy = null
}: {
    SitePicker?: ReactNode;
    SiteNameInput?: ReactNode;
    SiteToggleButton?: ReactNode;
    SubmitButton?: ReactNode;
    PrivacyPolicy?: ReactNode;
}) => {
    const { showSitePicker, activateSite, sitesWithoutCurrentProduct } =
        useSiteActivationContext();

    const activateSiteWithPrivacyPolicy = () => {
        const privacyPolicy =
            document.getElementById("privacy-policy-text")?.innerHTML || "";
        activateSite({ privacyPolicy });
    };

    const privacyPolicyEnabled = checkFeatureFlagGate(
        featureFlags.jfindSiteActivationPrivacyPolicy
    );

    return (
        <Form onSubmit={activateSiteWithPrivacyPolicy} isDisabled={false}>
            {({ formProps }) => (
                <form
                    {...formProps}
                    autoComplete="off"
                    css={containerCss}
                    data-testid="existing-sites-site-activation"
                >
                    <div>
                        {showSitePicker && <>{SitePicker}</>}
                        {!showSitePicker && <>{SiteNameInput}</>}
                        {sitesWithoutCurrentProduct.length > 0 && (
                            <>{SiteToggleButton}</>
                        )}
                    </div>
                    {SubmitButton}
                    {privacyPolicyEnabled && (
                        <div id="privacy-policy-text">{PrivacyPolicy}</div>
                    )}
                </form>
            )}
        </Form>
    );
};

const containerCss = css({
    display: "grid",
    gap: "24px"
});
